
import React from "react";

const CallAction = () => (
    <>
    <div className="container my-5">
        <p className="" style={{
            color: "#2D94F3", fontSize: "2rem",
            textAlign: "center"
        }}>Book a Call to Get Your Custom Strategy</p>
        <div className="row d-flex justify-content-center">
            <div data-sal="slide-up" className="col p-5">
                <div className="d-flex justify-content-center">

                    <lottie-player src="https://assets10.lottiefiles.com/packages/lf20_N1ffOJ.json" background="transparent" speed="1.7" style={{ width: "15rem", height: "15rem" }} loop autoplay></lottie-player>
                </div>

                <p style={{ fontSize: "2rem", textAlign: "center" }}>Business Audit</p>
                <p style={{ textAlign: "center" }}>We analyze your current website(if any), your industry, and your competitors to show you the opportunities to acheive your goals through a high converting website.</p>
            </div>
            <div data-sal="slide-up" className="col p-5">
                <div className='d-flex justify-content-center'>

                    <lottie-player src="https://assets1.lottiefiles.com/packages/lf20_qq5qecip.json" background="transparent" speed="1.7" style={{ width: "17rem", height: "15rem" }} loop autoplay></lottie-player>
                </div>

                <p style={{ fontSize: "2rem", textAlign: "center" }}>Action Plan</p>
                <p style={{ textAlign: "center" }}>Get a detailed execution plan for how we can acheive the look you want for your website.</p>
            </div>
            <div data-sal="slide-up" className="col p-5">
                <div className='d-flex justify-content-center'>

                    <lottie-player src="https://assets7.lottiefiles.com/packages/lf20_hadzves0.json" background="transparent" speed="1.7" style={{ width: "15rem", height: "15rem" }} loop autoplay></lottie-player>
                </div>

                <p style={{ fontSize: "2rem", textAlign: "center" }}>Quote</p>
                <p style={{ textAlign: "center" }}>We will give you detailed pricing on how much it will cost and timelines.</p>
            </div>
        </div>
    </div>


</>
)


export default CallAction;